import Modal from '@/core/Modal';
import clsx from 'clsx';
import { useState } from 'react';

function ModalSearchContent({ onOpenChange }) {
  const [tab, setTab] = useState('همه');

  const [search, setSearch] = useState('');

  return (
    <Modal width="620" height="500" onOpenChange={onOpenChange}>
      <input
        type="text"
        name="search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="با وارد کردن کلمات خود جستجو را آغاز کنید"
        className="h-16 w-full px-7 bg-gray"
      />
      <div className="p-4 flex flex-col w-full">
        <div className="border-b-1 border-light-grey pb-2 relative">
          <div className="grid grid-cols-5 w-fit text-center">
            <div className="w-[76px]">
              <input
                type="radio"
                className="hidden peer"
                checked={tab == 'همه'}
                id="همه"
                value="همه"
                onChange={(e) => setTab(e.target.value)}
                name="category"
              ></input>
              <label
                className="px-2 peer-checked:text-primary text-text-normal peer-checked:font-medium cursor-pointer"
                htmlFor="همه"
              >
                همه
              </label>
            </div>
            <div className="w-[76px]">
              <input
                type="radio"
                className="hidden peer"
                checked={tab == 'آگهی ها'}
                id="آگهی ها"
                value="آگهی ها"
                onChange={(e) => setTab(e.target.value)}
                name="category"
              ></input>
              <label
                className="px-2 peer-checked:text-primary text-text-normal peer-checked:font-medium cursor-pointer"
                htmlFor="آگهی ها"
              >
                آگهی ها
              </label>
            </div>
            <div className="w-[76px]">
              <input
                type="radio"
                className="hidden peer"
                checked={tab == 'مشاورین'}
                id="مشاورین"
                value="مشاورین"
                onChange={(e) => setTab(e.target.value)}
                name="category"
              ></input>
              <label
                className="px-2 peer-checked:text-primary text-text-normal peer-checked:font-medium cursor-pointer"
                htmlFor="مشاورین"
              >
                مشاورین
              </label>
            </div>
            <div className="w-[76px]">
              <input
                type="radio"
                className="hidden peer"
                checked={tab == 'مشتریان'}
                id="مشتریان"
                value="مشتریان"
                onChange={(e) => setTab(e.target.value)}
                name="category"
              ></input>
              <label
                className="px-2 peer-checked:text-primary text-text-normal peer-checked:font-medium cursor-pointer"
                htmlFor="مشتریان"
              >
                مشتریان
              </label>
            </div>
            <div className="w-[76px]">
              <input
                type="radio"
                className="hidden peer"
                checked={tab == 'یادآورها'}
                id="یادآورها"
                value="یادآورها"
                onChange={(e) => setTab(e.target.value)}
                name="category"
              ></input>
              <label
                className="px-2 peer-checked:text-primary text-text-normal peer-checked:font-medium cursor-pointer"
                htmlFor="یادآورها"
              >
                یادآورها
              </label>
            </div>
          </div>
          <span
            className={clsx(
              'absolute -bottom-[2px] w-[38px] h-[4px] rounded-md bg-primary transition-all',
              tab == 'همه' && 'right-[19px]',
              tab == 'آگهی ها' && 'right-[95px]',
              tab == 'مشاورین' && 'right-[171px]',
              tab == 'مشتریان' && 'right-[247px]',
              tab == 'یادآورها' && 'right-[323px]',
            )}
          ></span>
        </div>
      </div>
      <div className="px-6 overflow-y-scroll w-full h-[400px]">
        {search ? (
          <div className="flex flex-col items-center justify-center h-full w-full gap-1.5">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                opacity="0.4"
                d="M54.7352 21.3333H9.2631C5.86767 21.3333 3.33672 24.4641 4.04816 27.7841L8.85905 50.235C9.91292 55.153 14.2592 58.6666 19.2889 58.6666H44.7094C49.7391 58.6666 54.0854 55.153 55.1393 50.235L59.9502 27.7841C60.6616 24.4641 58.1307 21.3333 54.7352 21.3333Z"
                fill="#242424"
              />
              <path
                d="M53.3327 21.3333V18.6666C53.3327 14.2484 49.751 10.6666 45.3327 10.6666H37.8593C36.0779 10.6666 34.3474 10.072 32.9421 8.97705L30.4343 7.02291C29.0291 5.92793 27.2986 5.33331 25.5171 5.33331H18.666C14.2477 5.33331 10.666 8.91504 10.666 13.3333V21.3333H53.3327Z"
                fill="#242424"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.3333 34C30.756 34 28.6667 36.0893 28.6667 38.6667C28.6667 41.244 30.756 43.3333 33.3333 43.3333C35.9107 43.3333 38 41.244 38 38.6667C38 36.0893 35.9107 34 33.3333 34ZM24.6667 38.6667C24.6667 33.8802 28.5469 30 33.3333 30C38.1198 30 42 33.8802 42 38.6667C42 43.4531 38.1198 47.3333 33.3333 47.3333C31.6647 47.3333 30.1062 46.8618 28.7838 46.0446L25.4142 49.4142C24.6332 50.1953 23.3668 50.1953 22.5858 49.4142C21.8047 48.6332 21.8047 47.3668 22.5858 46.5858L25.9554 43.2162C25.1382 41.8938 24.6667 40.3353 24.6667 38.6667Z"
                fill="#242424"
              />
            </svg>
            <p className="text-text-hard text-lg font-bold">نتیجه ای یافت نشد</p>
            <p className="text-text-normal text-sm">کلمه دیگری را امتحان کنید</p>
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-1 text-primary">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#2563EB" stroke-width="1.5" />
                <path
                  d="M13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12Z"
                  stroke="#2563EB"
                  stroke-width="1.5"
                />
                <path
                  d="M13.4996 12H18.5996M11.9996 6.60001C11.9998 8.35737 11.9996 10.5 11.9996 10.5"
                  stroke="#2563EB"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p className="font-medium">جستجوهای اخیر</p>
            </div>
            <p className="text-light-grey">هنوز تاریخچه ای وجود ندارد</p>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default ModalSearchContent;
